export default function XSD_Reference() {
  return (
    <div>
      <h1>XSD_Reference</h1>
      <p>This is the XSD_Reference component.</p>
    </div>
  );
}